import { DashboardWidgetSection } from "../components/Dashboard/Dashboard"
import { WidgetContractorOrderStatus } from "./WidgetContractorOrderStatus"
import { WidgetDevicesOrderedByType } from "./WidgetDevicesOrderedByType"

export const OrdersSection = () => {
  return (
    <DashboardWidgetSection title="Orders">
      <WidgetDevicesOrderedByType />
      <WidgetContractorOrderStatus />
    </DashboardWidgetSection>
  )
}
